/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-13 14:16:51
 */

<!--批量导入界面-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">
        
        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <div>
                <a-card :title="$t('方案信息')" size="small">
                    <a-row :gutter="24">
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item has-feedback :label="$t('方案名称')" prop="fotaTaskName">
                                <a-input :placeholder="$t('请输入fota升级方案名称')" v-model.trim="model.fotaTaskName" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('旧固件型号')" prop="softwareOldName">
                                <a-input :placeholder="$t('请输入旧固件型号')" v-model="model.softwareOldName" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('新固件型号')" prop="softwareNewName">
                                <a-input :placeholder="$t('请输入新固件型号')" v-model="model.softwareNewName" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('旧固件版本')" prop="softwareOldVersion">
                                <a-input :placeholder="$t('请输入旧固件版本')" v-model="model.softwareOldVersion" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('新固件版本')" prop="softwareNewVersion">
                                <a-input :placeholder="$t('请输入新固件版本')" v-model="model.softwareNewVersion" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('旧固件字节数')" prop="softwareOldSize">
                                <a-input :placeholder="$t('请输入旧固件字节数')" v-model="model.softwareOldSize" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('新固件字节数')" prop="softwareNewSize">
                                <a-input :placeholder="$t('请输入新固件字节数')" v-model="model.softwareNewSize" :readOnly="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <!--
                        <a-col :span="8">
                            <a-upload name="file" 
                                :multiple="false" 
                                accept=".bin"
                                :fileList="fileNewList" 
                                :headers="tokenHeader"
                                :beforeUpload="beforeNewUpload"
                                :remove="handleNewRemove"
                                :disabled="disableSubmit"
                                > 
                                <a-button :disabled="disableSubmit">
                                    <a-icon type="upload" />
                                    选择新固件文件导入
                                </a-button>
                            </a-upload>
                        </a-col>
                        -->
                    </a-row>
                        
                </a-card>
                    <!--
                    <a-card title="旧固件信息" size="small">
                        <a-col :span="8">
                            <a-upload name="file" 
                                :multiple="false" 
                                accept=".bin"
                                :fileList="fileOldList" 
                                :headers="tokenHeader"
                                :beforeUpload="beforeOldUpload"
                                :remove="handleOldRemove"
                                :disabled="disableSubmit"
                                > 
                                <a-button :disabled="disableSubmit">
                                    <a-icon type="upload" />
                                    选择旧固件文件导入
                                </a-button>
                            </a-upload>
                        </a-col>
                        
                    </a-card>
                    -->
                
                <a-card :title="$t('固件导入')" size="small">
                    <a-row :gutter="24">
                        <a-col :span="8">
                            <a-upload name="file" 
                                :multiple="false" 
                                accept=".bin"
                                :fileList="fileFotaList" 
                                :headers="tokenHeader"
                                :beforeUpload="beforeFotaUpload"
                                :remove="handleFotaRemove"
                                :disabled="disableSubmit"
                                > 
                                <a-button :disabled="disableSubmit">
                                    <a-icon type="upload" />
                                    {{ $t('选择差分文件导入') }}
                                </a-button>
                            </a-upload>
                        </a-col>
                        <a-col :span="8" v-if="fileFotaList.length>0">
                            {{ $t('文件大小:') }}{{fileFotaList[0].size}}
                        </a-col>
                        <!--
                        <a-col :xl="8" :lg="8" :md="8" :sm="24">
                            <a-form-model-item label="参数个数" prop="fotaParaNum">
                                <a-input-number style="width: 100%" placeholder="请输入fota参数个数" :precision="0" v-model="model.fotaParaNum" :readOnly="disableSubmit"></a-input-number>
                            </a-form-model-item>
                        </a-col>
                        -->
                        <a-col :xl="24" :lg="24" :md="24" :sm="24">
                            <a-form-model-item :label="$t('fota参数')" prop="fotaParas">
                                <a-textarea rows="3" style="width: 100%" :placeholder="$t('请输入fota参数内容')" v-model="model.fotaParas" :readOnly="disableSubmit" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="24" :lg="24" :md="24" :sm="24">
                            <a-form-model-item :label="$t('描述')" prop="remark">
                                <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%" :readOnly="disableSubmit" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-card>
            </div>
        </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
    import { httpAction,getAction,uploadAction } from '@/api/manage'
    import { ACCESS_TOKEN } from "@/store/mutation-types"
    import {isUndefined} from'@/utils/validate'
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'softwareModal',
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                    visible: false,
                disableSubmit:false,
                tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
                maskClosable:false,
                model: {
                    softwareNewName: '',
                    softwareNewVersion: '',
                    softwareOldName: '',
                    softwareOldVersion: '',
                    fotaTaskName: '',
                    fotaParaNum: '',
                    fotaParas: ''
                },
                confirmLoading: false,
                url: {
                    add: "/jeecg-charge/meter/meterFotaSoft/add",
                    edit: "/jeecg-charge/meter/meterFotaSoft/edit",
                    queryFotaTaskNameByUserId: "/jeecg-charge/meter/meterFotaSoft/list"
                },
                fileNewList: [],
                fileOldList: [],
                fileFotaList: []
            }
        },
        computed: {
            // i18n：弹窗标题/校验规则使用 computed 以响应语言切换
            title() {
                return this.$t('操作')
            },
            rules() {
                return {
                    fotaTaskName:[{ required: true, message: this.$t('请输入升级方案名称')},{validator: this.validateFotaTaskName}],
                    softwareNewName:[{ required: true, message: this.$t('请输入正确的新固件型号'),pattern:/^[1-9]\d*$/}],
                    softwareOldName:[{ required: true, message: this.$t('请输入正确的旧固件型号'),pattern:/^[1-9]\d*$/}],
                    softwareNewVersion:[{ required: true, message: this.$t('请输入正确的新固件版本'),pattern:/^[1-9]\d*$/}],
                    softwareOldVersion:[{ required: true, message: this.$t('请输入正确的旧固件版本'),pattern:/^[1-9]\d*$/}],
                    softwareNewSize:[{ required: true, message: this.$t('请输入正确的新固件字节数'),pattern:/^[1-9]\d*$/}],
                    softwareOldSize:[{ required: true, message: this.$t('请输入正确的旧固件字节数'),pattern:/^[1-9]\d*$/}],
                    //fotaParaNum:[{ required: true, message: '请输入fota参数个数'}],
                    fotaParas:[{ required: true, message: this.$t('请输入fota参数内容')}],
                }
            }
        },
        created () {
        
        },
        methods: {
            ...mapGetters(["userInfo"]),
            add() {
                this.edit({});
            },
            edit (record) {
                this.visible = true;
                this.model = Object.assign(this.model,record)
                this.setFile()
            },
            setFile() {
                /*
                if(this.model.softwareNewFile) {
                    let index = this.model.softwareNewFile.lastIndexOf('/')
                    let name = ''
                    if(index>-1) {
                        name = this.model.softwareNewFile.substr(index+1)
                    }
                    this.fileNewList = [
                        {
                            uid: '1',
                            name: name,
                            status: 'done',
                            url: this.model.softwareNewFile
                        }
                    ]
                }
                if(this.model.softwareOldFile) {
                    let index = this.model.softwareOldFile.lastIndexOf('/')
                    let name = ''
                    if(index>-1) {
                        name = this.model.softwareOldFile.substr(index+1)
                    }
                    this.fileOldList = [
                        {
                            uid: '1',
                            name: name,
                            status: 'done',
                            url: this.model.softwareOldFile
                        }
                    ]
                }
                */
                if(this.model.fotaFilePath) {
                    let index = this.model.fotaFilePath.lastIndexOf('/')
                    let name = ''
                    if(index>-1) {
                        name = this.model.fotaFilePath.substr(index+1)
                    }
                    this.fileFotaList = [
                        {
                            uid: '1',
                            name: name,
                            status: 'done',
                            url: this.model.fotaFilePath
                        }
                    ]
                }
            },
            handleOk(){
                const that = this;
                /*
                if(this.fileNewList.length==0) {
                    this.$message.error("请先导入新固件文件")
                    return
                }
                if(this.fileOldList.length==0) {
                    this.$message.error("请先导入旧固件文件")
                    return
                }
                */
                if(this.fileFotaList.length==0) {
                    this.$message.error(this.$t("请先导入差分文件"))
                    return
                }
                // 触发表单验证
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                        // 增加差分文件和输入参数的对比
                        let result = this.validateSoftWareInfo();
                        if(!result.success) {
                            this.$message.error(result.resultMessage);
                            return;
                        }
                        
                        let length = that.model.fotaParas.split(',').length
                        /*
                        if(length!==that.model.fotaParaNum) {
                            that.$message.error("参数个数和参数内容个数不一致!")
                            return;
                        }
                        */
                        that.confirmLoading = true;
                        let httpurl = '';
                        let method = '';
                        if(!that.model.id){
                            httpurl+=that.url.add;
                            method = 'post';
                        }else{
                            httpurl+=that.url.edit;
                            method = 'put';
                        }
                        console.log('lalala')
                        let formData = new FormData();
                        console.log(that.model)
                        formData.append('softwareNewName', that.model.softwareNewName)
                        formData.append('softwareNewVersion', that.model.softwareNewVersion)
                        formData.append('softwareOldName', that.model.softwareOldName)
                        formData.append('softwareOldVersion', that.model.softwareOldVersion)
                        formData.append('fotaTaskName',that.model.fotaTaskName)
                        formData.append('softwareNewSize', that.model.softwareNewSize)
                        formData.append('softwareOldSize', that.model.softwareOldSize)
                        formData.append('fotaParaNum',length)
                        formData.append('fotaParas',that.model.fotaParas.replace(/\s/g,""))
                        if(that.model.remark) {
                            formData.append('remark',that.model.remark)
                        }
                        
                        const { fileNewList,fileOldList,fileFotaList } = that;
                        /*
                        fileNewList.forEach((file) => {
                            formData.append('softwareNewFile', file);
                        });
                        fileOldList.forEach((file) => {
                            formData.append('softwareOldFile', file);
                        });
                        */
                        fileFotaList.forEach((file) => {
                            formData.append('fotaFile', file);
                        });
                        console.log("表单提交数据",formData)
                        uploadAction(httpurl,formData).then((res)=>{
                        if(res.success){
                            that.$message.success(res.message);
                            that.$emit('ok');
                        }else{
                            that.$message.warning(res.message);
                        }
                        }).finally(() => {
                            that.confirmLoading = false;
                        })
                    }
                })
            },
            validateSoftWareInfo() {
                let fileName = this.fileFotaList[0].name
                let lastIndex = fileName.lastIndexOf('.')
                let fileNameStr = fileName.substr(0,lastIndex)
                console.log(fileNameStr)
                let fileArr = fileNameStr.split('_')
                console.log(fileArr.length)
                if(fileArr.length<4) {
                    return {success: false,resultMessage: this.$t('差分文件命名不正确')};
                }
                let softwareOldName = fileArr[0]
                let softwareOldVersion = fileArr[1]
                let softwareNewName = fileArr[2]
                let softwareNewVersion = fileArr[3]
                if(softwareOldName!=this.model.softwareOldName||softwareNewName!=this.model.softwareNewName
                    ||softwareOldVersion!=this.model.softwareOldVersion||softwareNewVersion!=this.model.softwareNewVersion) {
                        return {success: false,resultMessage: this.$t('差分文件中的信息和方案中的信息不一致，请确认后重新输入！')};
                }
                return {success: true,resultMessage: this.$t('正确')};
            },
            handleNewRemove(file) {
                const index = this.fileNewList.indexOf(file);
                const newFileList = this.fileNewList.slice();
                newFileList.splice(index, 1);
                this.fileNewList = newFileList;
            },
            beforeNewUpload(file) {
                this.fileNewList = [file];
                return false;
            },
            handleOldRemove(file) {
                const index = this.fileOldList.indexOf(file);
                const newFileList = this.fileOldList.slice();
                newFileList.splice(index, 1);
                this.fileOldList = newFileList;
            },
            beforeOldUpload(file) {
                this.fileOldList = [file];
                return false;
            },
            handleFotaRemove(file) {
                const index = this.fileFotaList.indexOf(file);
                const newFileList = this.fileFotaList.slice();
                newFileList.splice(index, 1);
                this.fileFotaList = newFileList;
            },
            beforeFotaUpload(file) {
                // 增加文件命令规则判断

                this.fileFotaList = [file];
                console.log(file.size)
                return false;
            },
            close () {
                this.$emit('close');
                this.model = this.$options.data.call(this).model
                this.$refs.formModal.resetFields()
                this.fileNewList = []
                this.fileOldList = []
                this.fileFotaList = []
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            },
            validateFotaTaskName(rule, value, callback){
                if(isUndefined(value)) {
                    callback()
                    return
                }
                let org = this.userInfo().orgCode
                let params = {fotaTaskName: this.model.fotaTaskName,sysOrgCode: org}
                getAction(this.url.queryFotaTaskNameByUserId,params).then((res) => {
                    if (res.success&&res.result.records.length>0) {
                        if(this.model.id&&res.result.records[0].id === this.model.id) {
                            callback()
                        }else{
                            callback(this.$t("该方案名称已存在，请重新输入!"))
                        }
                    } else {
                        callback()
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>